export default __webpack_public_path__ + "static/bicicletaAmarilla-1714e1450a74847a92b3c55999fcbfcb.png";